import { render } from "./CalendarEvents2.vue?vue&type=template&id=4f1bbfe9"
import script from "./CalendarEvents2.vue?vue&type=script&lang=js"
export * from "./CalendarEvents2.vue?vue&type=script&lang=js"

import "./CalendarEvents2.vue?vue&type=style&index=0&id=4f1bbfe9&lang=css"

import exportComponent from "/Users/smzdm/Desktop/前端项目/畅效官网/cx_official_website/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__